/**
 * Renders the current URL parameters based on global filters.
 */
export default function renderUrlParams() {
	// Encode the global filters into URL parameters
	const urlParams = global.filters;

	// Function to handle array and encode URI components
	const handleArray = (key, array) => {
		return array
			.map(
				(value) =>
					`${encodeURIComponent(key)}=${encodeURIComponent(value)}`
			)
			.join('&');
	};

	let queryParams = Object.keys(urlParams)
		.map((key) => {
			const value = urlParams[key];
			if (typeof value === 'object' && !Array.isArray(value)) {
				// Convert objects to JSON strings
				return Object.keys(value)
					.map(
						(subKey) =>
							`${encodeURIComponent(
								`${key}_${subKey}`
							)}=${encodeURIComponent(
								JSON.stringify(value[subKey])
							)}`
					)
					.join('&');
			} else if (Array.isArray(value)) {
				// Handle arrays
				return handleArray(key, value);
			}
			// Handle simple key-value pairs
			return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
		})
		.join('&');

	// Remove the first & from the queryParams
	queryParams = queryParams.replace(/^&/, '');

	// Construct the new URL with the updated parameters
	const url = window.location.href.split('?')[0] + '?' + queryParams;

	// Update the browser history with the new URL
	window.history.pushState({ path: url }, '', url);
}
